// Backward-compat shim — file moved to ./feature-flags/global-feature-flags-context
export * from "./feature-flags/global-feature-flags-context";
